module.exports = __webpack_public_path__ + "static/media/peeled_tomatoes.4e7e65e2.png";